export default {
  methods: {
    removeApplyFilterKeyEventListeners() {
      document.removeEventListener('keydown', this.applyFilterEventListener)
      document.removeEventListener('keyup', this.resetKeysEventListener)
    }
  }
}
